'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var fa = require('react-icons/fa');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const styledComponent = (horizontal = false) => {
    let styleToApply = '';
    if (horizontal === true) {
        styleToApply = 'mt-3 horizontal';
    }
    else {
        styleToApply = 'mt-3 vertical';
    }
    return styleToApply;
};
const Loading = ({ message, size, horizontal }) => {
    const styledDiv = styledComponent(horizontal);
    return (React__default["default"].createElement("div", { className: "mx-auto text-center" },
        React__default["default"].createElement("div", { className: styledDiv },
            React__default["default"].createElement(fa.FaSyncAlt, { className: "loading-icon mr-3", size: size }),
            React__default["default"].createElement("div", null, message))));
};
Loading.defaultProps = {
    message: 'Loading...',
    size: '1em',
    horizontal: false,
};

exports["default"] = Loading;
